<modal [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
    <p>L'identité du représentant légal de votre entreprise n'est pas renseigné.</p>
    <p>Vous ne pouvez malheureusement pas continuer votre commande en ligne.</p>
    <p>
        Vous avez la possibilité de passer votre commande dans l'une de nos boutiques
        <br />
        Bouygues Telecom avec les documents suivants :
    </p>
    <div class="alert has-body is-small is-shadowless has-body">
        <div class="icon">
            <i class="tri-infos-circle"></i>
        </div>
        <div class="body has-text-left has-text-weight-bold">
            <ul class="list">
                <li>Extrait de Kbis de moins de 3 mois</li>
                <li>Le RIB de votre entreprise</li>
                <li>Votre pièce d'identité</li>
            </ul>
        </div>
    </div>

    <ng-template #customModalFooter>
        <button class="button is-conversion" (click)="close()">Trouver une boutique</button>
    </ng-template>
</modal>
